import { LazyMotion, domAnimation, MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

/**
 * App-wide motion context.
 * - LazyMotion + domAnimation keeps the bundle small (~15kb) — covers
 *   animate / variants / whileInView / whileHover / whileTap / exit.
 * - `strict` forbids the full-fat `motion.*` so everything stays on `m.*`.
 * - reducedMotion="user" auto-neutralizes transform/opacity for users who
 *   request reduced motion (belt-and-suspenders with per-primitive guards).
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
}
